module.exports = __webpack_public_path__ + "static/media/LaptopCorrigendum.f1ce3b7e.pdf";